import "core-js/modules/es.array.map.js";
import React from 'react';
import { Card, Cards } from '../../Grid';
import { CategoryCard, CategoriesTable } from '../../Products';
import { Inner } from './partials';
var breakpoints = [{
  screen: 'miniPhone',
  columns: 1
}, {
  screen: 'phone',
  columns: 1
}, {
  screen: 'phablet',
  columns: 2
}, {
  screen: 'tablet',
  columns: 3
}, {
  screen: 'miniDesktop',
  columns: 4
}, {
  screen: 'desktop',
  columns: 4
}, {
  screen: 'bigScreen',
  columns: 4
}];
export var CategoriesList = function CategoriesList(_ref) {
  var productType = _ref.productType,
    categories = _ref.categories,
    view = _ref.view;
  return React.createElement(Inner, null, view === 'table' ? React.createElement("div", {
    style: {
      overflowX: 'auto'
    }
  }, React.createElement(CategoriesTable, {
    categories: categories,
    productType: productType
  })) : null, view === 'grid' ? React.createElement(Cards, {
    breakpoints: breakpoints
  }, categories.map(function (category) {
    return React.createElement(Card, {
      key: category.id
    }, React.createElement(CategoryCard, {
      key: category.id,
      category: category,
      productType: productType
    }));
  })) : null);
};